import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import { Layout, Typography, Form, Collapse } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import appLabel from "../../../../config/appLabel";
import appStatic from "../../../../config/appStatic";
import definedApi from "../../../../services/definedApi";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import RecordStatus from "../../../../components/RecordStatus";
import LoanProductTabs from "./LoanProductTabs";

const ViewPRD0200 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const { monthList } = appStatic;
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [loanProductDetails, setLoanProductDetails] = useState([]);
  const [editing, setEditing] = useState(true);

  function onEditModeCancel() {
    setEditing(true);
  }

  useEffect(() => {
    getDetailById(state);
  }, []);

  const getDetailById = (params) => {
    const url = `${definedApi.ViewLoanProduct}/${params.key}?template=true`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setLoanProductDetails(objDetail);
        // console.log(objDetail)

        useForm.setFieldsValue({
          name: objDetail?.name,
          shortName: objDetail?.shortName,
          fundId: objDetail?.fundName,
          startDate: objDetail?.startDate
            ? `${objDetail?.startDate[2]} ${monthList[objDetail?.startDate[1] - 1]} ${objDetail?.startDate[0]}`
            : "-",
          closeDate: objDetail?.closeDate
            ? `${objDetail?.closeDate[2]} ${monthList[objDetail?.closeDate[1] - 1]} ${objDetail?.closeDate[0]}`
            : "-",
          description: objDetail?.description,
          currencyCode: objDetail?.currency?.code,
          digitsAfterDecimal: objDetail.currency.decimalPlaces,
          inMultiplesOf: objDetail?.currency.inMultiplesOf,
          installmentAmountInMultiplesOf: objDetail?.installmentAmountInMultiplesOf,
          includeInBorrowerCycle: objDetail?.includeInBorrowerCycle === true ? "Yes" : "No",
          minPrincipal: objDetail?.minPrincipal,
          principal: objDetail?.principal,
          maxPrincipal: objDetail?.maxPrincipal,
          minNumberOfRepayments: objDetail?.minNumberOfRepayments,
          numberOfRepayments: objDetail?.numberOfRepayments,
          maxNumberOfRepayments: objDetail?.maxNumberOfRepayments,
          minInterestRatePerPeriod: objDetail?.minInterestRatePerPeriod,
          interestRatePerPeriod: objDetail?.interestRatePerPeriod,
          maxInterestRatePerPeriod: objDetail?.maxInterestRatePerPeriod,
          interestRateFrequencyType: objDetail?.interestRateFrequencyType.value,
          repaymentEvery: objDetail?.repaymentEvery,
          repaymentFrequencyType: objDetail?.repaymentFrequencyType.value,
          minimumDaysBetweenDisbursalAndFirstRepayment:
            objDetail?.minimumDaysBetweenDisbursalAndFirstRepayment,
          isLinkedToFloatingInterestRates:
            objDetail?.isLinkedToFloatingInterestRates === true ? "Yes" : "No",
          useBorrowerCycle: objDetail?.useBorrowerCycle === true ? "Yes" : "No",
          amortizationType: objDetail?.amortizationType.value,
          interestType: objDetail?.interestType.value,
          interestCalculationPeriodType: objDetail?.interestCalculationPeriodType.value,
          transactionProcessingStrategyId: objDetail?.transactionProcessingStrategyName,
          graceOnPrincipalPayment: objDetail?.graceOnPrincipalPayment,
          graceOnInterestPayment: objDetail?.graceOnInterestPayment,
          graceOnInterestCharged: objDetail?.graceOnInterestCharged,
          inArrearsTolerance: objDetail?.inArrearsTolerance,
          daysInYearType: objDetail?.daysInYearType.value,
          daysInMonthType: objDetail?.daysInMonthType.value,
          // overdueDaysForNPA: objDetail?.repaymentEvery,
          // graceOnArrearsAgeing: objDetail?.repaymentEvery,
          principalThresholdForLastInstallment: objDetail?.principalThresholdForLastInstallment,
          isInterestRecalculationEnabled:
            objDetail?.isInterestRecalculationEnabled === true ? "Yes" : "No",
          holdGuaranteeFunds: objDetail?.holdGuaranteeFunds === true ? "Yes" : "No",
          allowAttributeConfiguration: "Yes",
          amortization: "Yes",
          transactionProcessingStrategy: "Yes",
          arrearsTolerance: "Yes",
          graceOnPrincipalAndInterest: "Yes",
          interestMethod: "Yes",
          interestCalcPeriod: "Yes",
          repaymentFrequency: "Yes",
          graceOnArrearsAging: "Yes",
          multiDisburseLoan: objDetail?.multiDisburseLoan === true ? "Yes" : "No",
          fundSourceAccountId: objDetail?.accountingMappings?.fundSourceAccount?.name,
          loanPortfolioAccountId: objDetail?.accountingMappings?.loanPortfolioAccount?.name,
          transfersInSuspenseAccountId:
            objDetail?.accountingMappings?.transfersInSuspenseAccount?.name,
          interestOnLoanAccountId: objDetail?.accountingMappings?.interestOnLoanAccount?.name,
          incomeFromFeeAccountId: objDetail?.accountingMappings?.incomeFromFeeAccount?.name,
          incomeFromPenaltyAccountId: objDetail?.accountingMappings?.incomeFromPenaltyAccount?.name,
          incomeFromRecoveryAccountId:
            objDetail?.accountingMappings?.incomeFromRecoveryAccount?.name,
          writeOffAccountId: objDetail?.accountingMappings?.writeOffAccount?.name,
          overpaymentLiabilityAccountId:
            objDetail?.accountingMappings?.overpaymentLiabilityAccount?.name,
          receivableInterestAccountId:
            objDetail?.accountingMappings?.receivableInterestAccount?.name,
          receivableFeeAccountId: objDetail?.accountingMappings?.receivableFeeAccount?.name,
          receivablePenaltyAccountId: objDetail?.accountingMappings?.receivablePenaltyAccount?.name,
          accountingRule: objDetail?.accountingRule?.id,
        });
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={appLabel.LoanProductDetail}
        pageItems={appStatic.viewLoanProductItems}
      />

      {/* PART 2 DISPLAY CONTENT */}
      <LoanProductTabs
        disabled={editing}
        onEditCancel={onEditModeCancel}
        formButtonState={editing}
        loanProductDetails={loanProductDetails}
        useForm={useForm}
      />

      {/* PART 3 DISPLAY  RECORD STATUS */}
      <RecordStatus authStatus={""} makerID={""} makerDate={""} checkerID={""} checkerDate={""} />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPRD0200);
